<div class="spec-table">
  <mat-expansion-panel *ngIf="specProductValues">
    <mat-expansion-panel-header class="pdp-spec-table-header">
      <mat-panel-title class="pdp-spec-table-label">
        {{ 'product.productOptions.productSpecTable.title' | cxTranslate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="spec-table-body">
      <table>
        <thead>
          <tr>
            <ng-container *ngFor="let headerId of specProductHeaders">
              <th>{{ headerId.headerName }}</th>
            </ng-container>
            <th>{{ 'product.productList.dealerPrice' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let value of specProductValues">
            <tr>
              <ng-container *ngFor="let headerId of specProductHeaders">
                <td>{{ checkTableId(value.values, headerId) }}</td>
              </ng-container>
              <td>{{ dealerPrice(value.code) }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
</div>
